"use strict";

module.exports = {
    "copyright": {
        "link": function(params) {
            return [params["content"], " LLC"];
        },
        "yandex": "YANDEX"
    }
};